import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { domainToRegex } from "../urlPatternConversion";
import logo from "./logo.svg";

export const sonarQube = defineConnector({
  identifier: "sonarQube",
  name: "SonarQube",
  tagLine: "Code quality and security analysis",
  logo,
  protocol: "http",
  tags: ["engineering", "security"],
  auth: (app) => bearerAuth(app.secret.token),
  steps: [
    {
      title: "Create a SonarQube user token",
      items: [
        {
          kind: "markdown",
          content:
            "In SonarQube, open **My Account → Security** and generate a user token for the Web API.",
        },
      ],
    },
    {
      title: "Enter your SonarQube details",
      items: [
        {
          kind: "url",
          label: "SonarQube URL",
          required: true,
          placeholder: "https://sonarqube.example.com",
          target: { kind: "configuration", field: "instanceUrl" },
        },
        {
          kind: "input",
          label: "User token",
          required: true,
          target: { kind: "secrets", field: "token" },
        },
      ],
    },
  ],
  defaultUrlPattern: ({ instanceUrl }) => domainToRegex(instanceUrl),
  connectionTest: {
    protocol: "http",
    request: ({ instanceUrl }) => `${instanceUrl}/api/authentication/validate`,
  },
});
